import React, { FunctionComponent } from 'react';
import { intervalToDuration } from 'date-fns';
import { Bookmark } from 'lucide-react';
import { MuxAnimatedGifUrlResponse } from '@companion-professional/dctypes';
import { linkVariants } from '@companion-professional/components';
import { cn, formatMinSecDuration } from '@companion-professional/webutils';

interface ClipsOfInterestProps {
  clips: MuxAnimatedGifUrlResponse[];

  // goToTime is a function that navigates the player to the specified time in seconds.
  goToTime: (timeInSeconds: number) => void;
}

// ClipsOfInterest displays a grid of clips of interest with their start and end times.
export const ClipsOfInterest: FunctionComponent<ClipsOfInterestProps> = ({ clips, goToTime }) => {
  return (
    <div className="grid flex-1 grid-cols-2 gap-4 lg:grid-cols-4">
      {clips.map((clip, index) => {
        const start = intervalToDuration({ start: 0, end: clip.start_sec * 1000 });
        const end = intervalToDuration({ start: 0, end: clip.end_sec * 1000 });

        return (
          <div
            key={index}
            className="flex cursor-pointer flex-col items-center justify-center gap-1 rounded-md p-2 hover:bg-accent"
            onClick={() => {
              goToTime(clip.start_sec);
            }}
          >
            <img alt={`Clip at ${clip.start_sec} seconds`} src={clip.url} className="max-h-[100px] bg-muted" />
            <div className={cn(linkVariants(), 'flex flex-row items-center justify-center gap-1')}>
              <Bookmark size="16" /> {formatMinSecDuration(start)} to {formatMinSecDuration(end)}
            </div>
          </div>
        );
      })}
    </div>
  );
};
